[
  {
    "id": "SR-E6P-POLITIE-V01",
    "module": "SpellingRegel",
    "difficulty": 106,
    "difficultyTier": 6,
    "levelCode": "E6+",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_tie_age",
    "familyId": "SR-WEETWOORD-TIE",
    "conceptId": "tie_spelling_rule",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["politie", "politsie", "politiee", "polietie"],
    "correctAnswer": 0,
    "explanation": "Je hoort 'tsie', maar schrijft '-tie'. Dit is een spellingregel voor woorden uit het Latijn. Andere voorbeelden: informatie, operatie, natie.",
    "distractorExplanations": {
      "1": "Je schrijft '-tie', niet '-tsie'. De 't' klinkt al als 'ts' vóór '-ie'.",
      "2": "Geen dubbele 'e' aan het eind. Het is '-tie', niet '-tiee'.",
      "3": "De 'i' zit in '-tie', niet ervoor. Het is poli-tie, niet polie-tie."
    }
  },
  {
    "id": "SR-E6P-BAGAGE-V01",
    "module": "SpellingRegel",
    "difficulty": 106,
    "difficultyTier": 6,
    "levelCode": "E6+",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_tie_age",
    "familyId": "SR-WEETWOORD-AGE",
    "conceptId": "age_spelling_rule",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["bagage", "bagaage", "bagagje", "baggage"],
    "correctAnswer": 0,
    "explanation": "Je hoort 'aazje', maar schrijft '-age'. Dit is een Franse spelling. Andere voorbeelden: garage, etage, massage.",
    "distractorExplanations": {
      "1": "Geen dubbele 'a'. Het is ba-ga-ge.",
      "2": "Geen '-gje'. De Franse uitgang is '-age'.",
      "3": "Geen dubbele 'g'. Het is ba-ga-ge met enkele g's."
    }
  },
  {
    "id": "SR-E6P-STATION-V01",
    "module": "SpellingRegel",
    "difficulty": 106,
    "difficultyTier": 6,
    "levelCode": "E6+",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_tie_age",
    "familyId": "SR-WEETWOORD-TION",
    "conceptId": "tion_spelling_rule",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["station", "stasion", "staation", "statjon"],
    "correctAnswer": 0,
    "explanation": "Je hoort 'sjon', maar schrijft '-tion'. Dit is een Latijnse spelling. De 't' klinkt als 'sj' vóór '-ion'.",
    "distractorExplanations": {
      "1": "Je schrijft '-tion', niet '-sion'. De 't' maakt het 'sj'-geluid.",
      "2": "Geen dubbele 'a'. Het is sta-tion.",
      "3": "Geen '-tjon'. Het is '-tion' zonder 'j'."
    }
  },
  {
    "id": "SR-E6P-SAVONDS-V01",
    "module": "SpellingRegel",
    "difficulty": 106,
    "difficultyTier": 6,
    "levelCode": "E6+",
    "group": 6,
    "skill": "schrijfwijze",
    "subSkill": "s_genitief",
    "familyId": "SR-S-GENITIEF",
    "conceptId": "genitive_s_apostrophe",
    "variantIndex": 4,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["'s avonds", "savonds", "s'avonds", "s avonds"],
    "correctAnswer": 0,
    "explanation": "Afkorting van 'des avonds'. Apostrof vóór de 's', dan een spatie: 's avonds.",
    "distractorExplanations": {
      "1": "Apostrof en spatie vergeten. Het is 's avonds.",
      "2": "De apostrof staat vóór de 's', niet erna.",
      "3": "De apostrof ontbreekt."
    }
  },
  {
    "id": "SR-E6P-IDEEEN-V01",
    "module": "SpellingRegel",
    "difficulty": 106,
    "difficultyTier": 6,
    "levelCode": "E6+",
    "group": 6,
    "skill": "schrijfwijze",
    "subSkill": "trema",
    "familyId": "SR-TREMA-MEERVOUD",
    "conceptId": "trema_plural_vowel_collision",
    "variantIndex": 4,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["ideeën", "ideeen", "ideen", "ideeén"],
    "correctAnswer": 0,
    "explanation": "Idee + en = ideeën. Het trema voorkomt dat je de klinkers als één klank leest.",
    "distractorExplanations": {
      "1": "Trema vergeten. Zonder trema is de uitspraak onduidelijk.",
      "2": "Er missen letters. Het is idee + en = ideeën.",
      "3": "Dit is een accent aigu (é), geen trema (ë)."
    }
  },
  {
    "id": "SR-E6P-INFORMATIE-V01",
    "module": "SpellingRegel",
    "difficulty": 106,
    "difficultyTier": 6,
    "levelCode": "E6+",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_tie_age",
    "familyId": "SR-WEETWOORD-TIE",
    "conceptId": "tie_spelling_rule",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["informatie", "informasie", "informacie", "informatsie"],
    "correctAnswer": 0,
    "explanation": "Je hoort 'tsie', maar schrijft '-tie'. Informatie, net als politie en operatie.",
    "distractorExplanations": {
      "1": "Geen '-sie'. De juiste uitgang is '-tie'.",
      "2": "Geen '-cie'. De juiste uitgang is '-tie'.",
      "3": "Geen '-tsie'. De 't' in '-tie' maakt al het 'ts'-geluid."
    }
  },
  {
    "id": "SR-E6P-GARAGE-V01",
    "module": "SpellingRegel",
    "difficulty": 106,
    "difficultyTier": 6,
    "levelCode": "E6+",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_tie_age",
    "familyId": "SR-WEETWOORD-AGE",
    "conceptId": "age_spelling_rule",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["garage", "garaazje", "garasje", "garrage"],
    "correctAnswer": 0,
    "explanation": "Je hoort 'aazje', maar schrijft '-age'. Garage, net als bagage en etage.",
    "distractorExplanations": {
      "1": "Schrijf '-age', niet '-aazje'. Dit is een Franse spelling.",
      "2": "Geen '-sje'. De juiste uitgang is '-age'.",
      "3": "Geen dubbele 'r'. Het is ga-ra-ge."
    }
  },
  {
    "id": "SR-E6P-VACATIE-V01",
    "module": "SpellingRegel",
    "difficulty": 106,
    "difficultyTier": 6,
    "levelCode": "E6+",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_tie_age",
    "familyId": "SR-WEETWOORD-TIE",
    "conceptId": "tie_spelling_rule",
    "variantIndex": 3,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["vacatie", "vakatie", "vacasie", "vakasie"],
    "correctAnswer": 0,
    "explanation": "'Vacatie' schrijf je met 'c' en '-tie'. De 'c' klinkt als 'k' (voor 'a'), en '-tie' klinkt als 'tsie'.",
    "distractorExplanations": {
      "1": "De 'c' klinkt als 'k', maar je schrijft 'c'. Het is een leenwoord.",
      "2": "Geen '-sie'. De juiste uitgang is '-tie'.",
      "3": "Dubbel fout: het begint met 'c' en eindigt op '-tie'."
    }
  },
  {
    "id": "SR-E6P-ACTIE-V01",
    "module": "SpellingRegel",
    "difficulty": 106,
    "difficultyTier": 6,
    "levelCode": "E6+",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_tie_age",
    "familyId": "SR-WEETWOORD-CTIE",
    "conceptId": "ctie_spelling_rule",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["actie", "aksie", "akcie", "actcie"],
    "correctAnswer": 0,
    "explanation": "'Actie' schrijf je met 'ct' + 'ie'. De combinatie 'ct' klinkt als 'ks' + 'tie' klinkt als 'tsie'.",
    "distractorExplanations": {
      "1": "Geen 'ks'. De juiste spelling is 'ct' + 'ie'.",
      "2": "Geen 'kc'. De juiste spelling is 'ct' + 'ie'.",
      "3": "Geen 'ctc'. Het is gewoon 'ct' + 'ie'."
    }
  },
  {
    "id": "SR-E6P-ETAGE-V01",
    "module": "SpellingRegel",
    "difficulty": 106,
    "difficultyTier": 6,
    "levelCode": "E6+",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_tie_age",
    "familyId": "SR-WEETWOORD-AGE",
    "conceptId": "age_spelling_rule",
    "variantIndex": 3,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["etage", "etaazje", "etasje", "etagge"],
    "correctAnswer": 0,
    "explanation": "Je hoort 'aazje', maar schrijft '-age'. Etage, net als garage en bagage.",
    "distractorExplanations": {
      "1": "Schrijf '-age', niet '-aazje'.",
      "2": "Geen '-sje'. De juiste uitgang is '-age'.",
      "3": "Geen dubbele 'g'. Het is e-ta-ge."
    }
  },
  {
    "id": "SR-E6P-GEUPLOAD-V01",
    "module": "SpellingRegel",
    "difficulty": 106,
    "difficultyTier": 6,
    "levelCode": "E6+",
    "group": 6,
    "skill": "schrijfwijze",
    "subSkill": "trema",
    "familyId": "SR-TREMA-VOORVOEGSEL",
    "conceptId": "trema_prefix_vowel_collision",
    "variantIndex": 2,
    "questionType": "multiple_choice",
    "question": "Welk woord heeft een trema?",
    "options": ["geüpload", "geuploaded", "ge-upload", "geuploadd"],
    "correctAnswer": 0,
    "explanation": "Na het voorvoegsel 'ge-' komt een 'u'. Om verwarring te voorkomen (je zou 'geu-' kunnen lezen), zet je een trema: geüpload.",
    "distractorExplanations": {
      "1": "Trema vergeten. Zonder trema zou je 'geu-pload' lezen.",
      "2": "Een streepje is niet de standaard oplossing. We gebruiken een trema.",
      "3": "Geen dubbele 'd' aan het eind."
    }
  },
  {
    "id": "SR-E6P-OPERATIE-V01",
    "module": "SpellingRegel",
    "difficulty": 106,
    "difficultyTier": 6,
    "levelCode": "E6+",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_tie_age",
    "familyId": "SR-WEETWOORD-TIE",
    "conceptId": "tie_spelling_rule",
    "variantIndex": 4,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["operatie", "operasie", "operacie", "operatsie"],
    "correctAnswer": 0,
    "explanation": "Je hoort 'tsie', maar schrijft '-tie'. Operatie, net als informatie en politie.",
    "distractorExplanations": {
      "1": "Geen '-sie'. De juiste uitgang is '-tie'.",
      "2": "Geen '-cie'. De juiste uitgang is '-tie'.",
      "3": "Geen '-tsie'. De 't' in '-tie' maakt al het 'ts'-geluid."
    }
  },
  {
    "id": "SR-E6P-MASSAGE-V01",
    "module": "SpellingRegel",
    "difficulty": 106,
    "difficultyTier": 6,
    "levelCode": "E6+",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_tie_age",
    "familyId": "SR-WEETWOORD-AGE",
    "conceptId": "age_spelling_rule",
    "variantIndex": 4,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["massage", "massaazje", "massasje", "massagge"],
    "correctAnswer": 0,
    "explanation": "Je hoort 'aazje', maar schrijft '-age'. Massage, net als garage en etage.",
    "distractorExplanations": {
      "1": "Schrijf '-age', niet '-aazje'.",
      "2": "Geen '-sje'. De juiste uitgang is '-age'.",
      "3": "Geen dubbele 'g'. Het is mas-sa-ge."
    }
  },
  {
    "id": "SR-E6P-NATIE-V01",
    "module": "SpellingRegel",
    "difficulty": 106,
    "difficultyTier": 6,
    "levelCode": "E6+",
    "group": 6,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_tie_age",
    "familyId": "SR-WEETWOORD-TIE",
    "conceptId": "tie_spelling_rule",
    "variantIndex": 5,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["natie", "nasie", "nacie", "natsie"],
    "correctAnswer": 0,
    "explanation": "Je hoort 'tsie', maar schrijft '-tie'. Natie, net als politie en informatie.",
    "distractorExplanations": {
      "1": "Geen '-sie'. De juiste uitgang is '-tie'.",
      "2": "Geen '-cie'. De juiste uitgang is '-tie'.",
      "3": "Geen '-tsie'. De 't' in '-tie' maakt al het 'ts'-geluid."
    }
  },
  {
    "id": "SR-E6P-TWEEEN-V01",
    "module": "SpellingRegel",
    "difficulty": 106,
    "difficultyTier": 6,
    "levelCode": "E6+",
    "group": 6,
    "skill": "schrijfwijze",
    "subSkill": "trema",
    "familyId": "SR-TREMA-MEERVOUD",
    "conceptId": "trema_plural_vowel_collision",
    "variantIndex": 5,
    "questionType": "multiple_choice",
    "question": "Welk woord heeft een trema?",
    "options": ["tweeën", "tweeen", "tween", "tweeèn"],
    "correctAnswer": 0,
    "explanation": "Twee + en = tweeën. Het trema voorkomt dat je 'tween' leest.",
    "distractorExplanations": {
      "1": "Trema vergeten. Zonder trema is de uitspraak onduidelijk.",
      "2": "Er missen letters. Het is twee + en = tweeën.",
      "3": "Dit is een accent grave (è), geen trema (ë)."
    }
  }
]